import React from "react";
import { CounterpartyEntityFilter } from "../CounterpartyEntityFilter/CounterpartyEntityFilter";
import {
    CustomersFilters,
    HAS_BILLABLE_CUSTOMER_LABEL,
    NO_BILLABLE_CUSTOMER_LABEL,
} from "./lib";

interface Props {
    filters: CustomersFilters;
    onChange: (value: CustomersFilters) => void;
    hideNoCustomer?: boolean;
}

export const CustomerFilter: React.FC<Props> = ({
    filters,
    onChange,
    hideNoCustomer,
}) => (
    <CounterpartyEntityFilter
        selectedIds={filters.customerIds}
        withEmpty={filters.withEmptyCustomer}
        hasAssigned={filters.hasCustomer}
        onChange={({ selectedIds, withEmpty, hasAssigned }) =>
            onChange({
                customerIds: selectedIds,
                withEmptyCustomer: withEmpty,
                hasCustomer: hasAssigned,
            })
        }
        emptyLabel={NO_BILLABLE_CUSTOMER_LABEL}
        hasAssignedLabel={HAS_BILLABLE_CUSTOMER_LABEL}
        noMatchLabel="No matching customer"
        hideEmptyRow={hideNoCustomer}
    />
);
